// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-page {
  min-height: 100%;
  padding: 32px;
  box-sizing: border-box;
  background: #030712;
  color: white;
}
.admin-header, .admin-message, .admin-section {
  max-width: 1300px;
  margin-left: auto;
  margin-right: auto;
}
.admin-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 24px;
  margin-bottom: 20px;
}
.admin-header h1 { margin: 0 0 8px; }
.admin-header p { margin: 0; color: #94a3b8; }
.admin-header button, .admin-table button {
  padding: 10px 15px;
  border: 1px solid rgba(255,255,255,0.16);
  border-radius: 9px;
  background: rgba(255,255,255,0.07);
  color: white;
  cursor: pointer;
  font-weight: 700;
}
.admin-table button.primary { background: #4f46e5; border-color: #4f46e5; }
.admin-table button:disabled { opacity: 0.5; cursor: default; }
.admin-section {
  margin-bottom: 28px;
}
.admin-section-header {
  margin-bottom: 12px;
}
.admin-section-header h2 {
  margin: 0 0 6px;
  font-size: 22px;
}
.admin-section-header p {
  margin: 0;
  color: #94a3b8;
}
.admin-message {
  margin-bottom: 14px;
  padding: 12px 16px;
  border-radius: 10px;
  background: rgba(79,70,229,0.15);
  color: #cbd5e1;
}
.admin-table-shell {
  overflow: auto;
  border: 1px solid rgba(255,255,255,0.1);
  border-radius: 16px;
  background: #0f172a;
}
.admin-table {
  width: 100%;
  border-collapse: collapse;
}
.admin-table th, .admin-table td {
  padding: 16px;
  border-bottom: 1px solid rgba(255,255,255,0.08);
  text-align: left;
  vertical-align: top;
}
.admin-table td { white-space: nowrap; }
.admin-table th {
  color: #94a3b8;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.admin-table input, .admin-table select {
  width: 190px;
  padding: 10px;
  border: 1px solid rgba(255,255,255,0.15);
  border-radius: 8px;
  background: rgba(255,255,255,0.06);
  color: white;
}
.admin-inline-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}
.admin-inline-actions button {
  white-space: nowrap;
}
.admin-muted {
  display: block;
  margin-top: 5px;
  color: #94a3b8;
  font-size: 12px;
}
.admin-member-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  min-width: 280px;
  max-width: 420px;
  white-space: normal;
}
.admin-member-pill {
  padding: 5px 8px;
  border: 1px solid rgba(148,163,184,0.26);
  border-radius: 999px;
  background: rgba(148,163,184,0.12);
  color: #cbd5e1;
  font-size: 12px;
}
.admin-account-table td:nth-child(6) {
  white-space: normal;
}
`, "",{"version":3,"sources":["webpack://./src/pages/AdminPage.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;AACA,mBAAmB,eAAe,EAAE;AACpC,kBAAkB,SAAS,EAAE,cAAc,EAAE;AAC7C;EACE,kBAAkB;EAClB,wCAAwC;EACxC,kBAAkB;EAClB,kCAAkC;EAClC,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;AACA,8BAA8B,mBAAmB,EAAE,qBAAqB,EAAE;AAC1E,+BAA+B,YAAY,EAAE,eAAe,EAAE;AAC9D;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,eAAe;AACjB;AACA;EACE,SAAS;EACT,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,cAAc;EACd,uCAAuC;EACvC,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,+CAA+C;EAC/C,gBAAgB;EAChB,mBAAmB;AACrB;AACA,kBAAkB,mBAAmB,EAAE;AACvC;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,aAAa;EACb,wCAAwC;EACxC,kBAAkB;EAClB,kCAAkC;EAClC,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,oBAAoB;EACpB,kCAAkC;EAClC,cAAc;EACd,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB","sourcesContent":[".admin-page {\n  min-height: 100%;\n  padding: 32px;\n  box-sizing: border-box;\n  background: #030712;\n  color: white;\n}\n.admin-header, .admin-message, .admin-section {\n  max-width: 1300px;\n  margin-left: auto;\n  margin-right: auto;\n}\n.admin-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 24px;\n  margin-bottom: 20px;\n}\n.admin-header h1 { margin: 0 0 8px; }\n.admin-header p { margin: 0; color: #94a3b8; }\n.admin-header button, .admin-table button {\n  padding: 10px 15px;\n  border: 1px solid rgba(255,255,255,0.16);\n  border-radius: 9px;\n  background: rgba(255,255,255,0.07);\n  color: white;\n  cursor: pointer;\n  font-weight: 700;\n}\n.admin-table button.primary { background: #4f46e5; border-color: #4f46e5; }\n.admin-table button:disabled { opacity: 0.5; cursor: default; }\n.admin-section {\n  margin-bottom: 28px;\n}\n.admin-section-header {\n  margin-bottom: 12px;\n}\n.admin-section-header h2 {\n  margin: 0 0 6px;\n  font-size: 22px;\n}\n.admin-section-header p {\n  margin: 0;\n  color: #94a3b8;\n}\n.admin-message {\n  margin-bottom: 14px;\n  padding: 12px 16px;\n  border-radius: 10px;\n  background: rgba(79,70,229,0.15);\n  color: #cbd5e1;\n}\n.admin-table-shell {\n  overflow: auto;\n  border: 1px solid rgba(255,255,255,0.1);\n  border-radius: 16px;\n  background: #0f172a;\n}\n.admin-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n.admin-table th, .admin-table td {\n  padding: 16px;\n  border-bottom: 1px solid rgba(255,255,255,0.08);\n  text-align: left;\n  vertical-align: top;\n}\n.admin-table td { white-space: nowrap; }\n.admin-table th {\n  color: #94a3b8;\n  font-size: 13px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n.admin-table input, .admin-table select {\n  width: 190px;\n  padding: 10px;\n  border: 1px solid rgba(255,255,255,0.15);\n  border-radius: 8px;\n  background: rgba(255,255,255,0.06);\n  color: white;\n}\n.admin-inline-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.admin-inline-actions button {\n  white-space: nowrap;\n}\n.admin-muted {\n  display: block;\n  margin-top: 5px;\n  color: #94a3b8;\n  font-size: 12px;\n}\n.admin-member-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  min-width: 280px;\n  max-width: 420px;\n  white-space: normal;\n}\n.admin-member-pill {\n  padding: 5px 8px;\n  border: 1px solid rgba(148,163,184,0.26);\n  border-radius: 999px;\n  background: rgba(148,163,184,0.12);\n  color: #cbd5e1;\n  font-size: 12px;\n}\n.admin-account-table td:nth-child(6) {\n  white-space: normal;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
